export default __webpack_public_path__ + "hero-next-992-b45ad60e2e9d11d940befacf855fc44e.bundle.webp";